import axios from 'axios';
const Config = require('~config/default.env').default;

const getCountries = (params) =>
  axios
    .get(`${Config.MS_SOCO_PUBLIC_API_URL}/countries`, { params })
    .then(({ data: { data } }) => data)
    .catch(console.log);

const getProvinces = () =>
  axios
    .get(`${Config.MS_SOCO_PUBLIC_API_URL}/provinces`, {
      params: {
        sort: 'name',
        limit: 999,
      },
    })
    .then(({ data: { data } }) => data)
    .catch(console.log);

const getCities = (params) =>
  axios
    .get(`${Config.MS_SOCO_PUBLIC_API_URL}/cities`, { params })
    .then(({ data: { data } }) => data)
    .catch(console.log);

const getDistricts = (params) =>
  axios
    .get(`${Config.MS_SOCO_PUBLIC_API_URL}/districts`, { params })
    .then(({ data: { data } }) => data)
    .catch(console.log);

const getPostalCodes = (params) =>
  axios
    .get(`${Config.MS_SOCO_PUBLIC_API_URL}/districts`, {
      params: { _id: params?.district_id, fields: 'name pin_codes' },
    })
    .then(({ data: { data } }) =>
      (data?.[0]?.pin_codes || []).map((code) => ({ _id: code, name: code })),
    )
    .catch(() => []);

export default {
  getCountries,
  getProvinces,
  getCities,
  getDistricts,
  getPostalCodes,
};
